import { createAsyncThunk } from "@reduxjs/toolkit";
import { EntitlementsApiService } from "api/entitlements.api";

import { deriveLaneKeys } from "./derive";

// Re-export so existing callers keep working — but tests should prefer to
// import from ./derive directly to avoid the axios-cache-interceptor chain.
export { deriveLaneKeys };

/**
 * Loads the current org's entitlements and derives the implied lane bundle
 * keys. One call per session unless explicitly refreshed.
 */
export const loadEntitlements = createAsyncThunk(
  "entitlements/load",
  async (_, { rejectWithValue }) => {
    try {
      const res = await EntitlementsApiService.list();
      // ResponseSuccess<object> wraps as { success, message, data }.
      const rows = res?.data?.data ?? res?.data ?? [];
      const featureKeys = (Array.isArray(rows) ? rows : [])
        .filter((r) => r && r.isEnabled !== false && r.featureKey)
        .map((r) => r.featureKey);
      const uniqueFeatureKeys = Array.from(new Set(featureKeys)).sort();
      const laneKeys = deriveLaneKeys(uniqueFeatureKeys);
      return { featureKeys: uniqueFeatureKeys, laneKeys };
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to load entitlements");
    }
  }
);
